import Backdrop from "./Backdrop";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import theme from "../theme/theme";
import { SUBMIT_USER_ANSWER_FAIL } from "../redux/action-types";

const BodyWrapper = styled.div`
  min-height: 100px;
  max-width: 40%;
  margin: 10em auto;
  background-color: white;
  padding: 1.5em;
  border-radius: 15px;
  text-align: left;
  @media (max-width: 480px) {
    padding: 1em;
    max-width: 70%;
    min-height: 100px;
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};
    @media (max-width: 480px) {
      font-size: 21px;
    }
  }

  .question-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    & p {
      margin: 10px 0;
    }
  }

  .question {
    color: #6ac7dd;
    font-size: 30px;
    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  .message {
    font-size: 20px;
    color: ${theme.colors.error};
    @media (max-width: 480px) {
      font-size: 15px;
    }
  }
`;

const ErrorHandligPopUp = ({ setErrHanlingVisible }) => {
  const { userQA, steps } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const message = userQA?.answersValidation.find(
    (answer) => !answer.isValidAnswer
  );
  const question = steps
    .map((step) => {
      const coincidenceQuest = step.questions.find(
        (step) => step.id === message?.questionId
      );
      if (coincidenceQuest) {
        return coincidenceQuest;
      }
      // eslint-disable-next-line array-callback-return
      return;
    })
    .find((quest) => quest !== undefined);

  return (
    <Backdrop>
      <BodyWrapper>
        <div className="headerMessage">
          Error
          <div
            onClick={() => {
              setErrHanlingVisible(false);
              dispatch({
                type: SUBMIT_USER_ANSWER_FAIL,
                payload: null,
              });
            }}
            style={{
              float: "right",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            X
          </div>
        </div>
        <div className="question-container">
          <p className="question">{question.text}</p>
          <p className="message">{message.validationError}</p>
        </div>
      </BodyWrapper>
    </Backdrop>
  );
};

export default ErrorHandligPopUp;
